// @flow
import React, { PureComponent } from 'react';
import { FlatList, Image, StyleSheet, View } from 'react-native';
import { BulletPoint, Link, Text } from 'trpc-react-native-ui';
import type { CountryType } from '../../config/iddCountries';
import theme from '../../theme-config';
import { Icon, Modal } from '../common';

export default class InternationalHeader extends PureComponent<Props, State> {
  state = {
    isModalOpen: false,
  };
  styles = getStyles();

  openModal = () => this.setState({ isModalOpen: true });
  closeModal = () => this.setState({ isModalOpen: false });
  renderCountry = ({ item: country }: { item: CountryType }) => <BulletPoint text={country.name} />;
  extractCountryId = (country: CountryType): string => country.id;
  getCountryLayout = (country: CountryType, index: number) => ({ length: 40, offset: 40 * index, index });

  render() {
    const styles = this.styles;
    return (
      <View style={styles.packageContainer}>
        {this.props.image ? (
          <Image source={this.props.image} style={this.props.imageStyle || styles.imageStyle} />
        ) : (
          <Icon name={this.props.iconName} color={this.props.iconColor} size={75} style={styles.icon} />
        )}
        <View style={styles.secondColumn}>
          <Text style={styles.title}>{this.props.title}</Text>
          {this.props.textLine1 && <Text style={styles.textLine}>{this.props.textLine1} </Text>}
          {this.props.textLine2 && <Text style={styles.textLine}>{this.props.textLine2}</Text>}
          {this.props.linkText && (
            <View style={styles.linkContainer}>
              <Link
                text={this.props.linkText}
                style={[styles.link, { color: theme.frame.linkColor }]}
                onPress={this.openModal}
              />
            </View>
          )}
        </View>
        {this.props.linkText && (
          <Modal visible={this.state.isModalOpen} requestClose={this.closeModal} fullScreen>
            <Text style={styles.modalTitle}>{this.props.linkText}</Text>
            <FlatList
              contentContainerStyle={styles.modalList}
              renderItem={this.renderCountry}
              data={this.props.countryList}
              keyExtractor={this.extractCountryId}
              getItemLayout={this.getCountryLayout}
              initialNumToRender={20}
            />
          </Modal>
        )}
      </View>
    );
  }
}

type Props = {
  iconName?: string,
  iconColor?: string,
  image?: number,
  imageStyle?: Object,
  title: string,
  textLine1: string,
  textLine2?: string,
  linkText?: string,
  countryList?: CountryType[],
};

type State = {
  isModalOpen: boolean,
};

const getStyles = () =>
  StyleSheet.create({
    icon: {
      flex: 1,
      marginLeft: 12,
      marginRight: 17,
    },
    imageStyle: {
      height: 75,
      resizeMode: 'stretch',
      width: 75,
    },
    link: {
      fontSize: 12,
      marginTop: 20,
    },
    linkContainer: {
      alignItems: 'flex-end',
      width: '100%',
    },
    modalList: {
      paddingHorizontal: 30,
    },
    modalTitle: {
      alignSelf: 'center',
      marginVertical: 20,
    },
    packageContainer: {
      alignItems: 'center',
      backgroundColor: theme.topUp.header.backgroundColor,
      flexDirection: 'row',
      paddingVertical: 12,
      marginBottom: 10,
    },
    secondColumn: {
      flex: 2.5,
      paddingRight: 12,
    },
    textLine: {
      color: theme.defaultTextColor,
      fontSize: 14,
    },
    title: {
      color: theme.defaultTextColor,
      fontSize: 16,
      fontWeight: '500',
      marginBottom: 15,
    },
  });
